var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{staticClass:"lock-check-button",attrs:{"icon":_vm.value ? 'lock' : 'lock_open',"color":"grey","icon-color":"black","variant":"flat","disabled":_vm.disabled},on:{"click":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }